import React from 'react';
import styled from 'styled-components';
import { gutter } from '../../styles/mixins';

const Host = styled.div`
  padding: ${gutter(1)} 0;
`;

interface AccordionProps {
  children: React.ReactNode;
}

export const Accordion = ({ children }: AccordionProps) => {
  return <Host>{children}</Host>;
};
